/* import axios from 'axios' */
import {
    axiosJwt
} from '@/shared/auth/axios-lib'
import {
    errorHandler
} from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_PATH}`

export default {
    excluir(seguro) {
        return axiosJwt.delete(`${api}/contratos/${seguro.idContrato}/segurosgarantias/${seguro.idSeguroGarantiaContrato}`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    inserir(seguro) {
        const formData = new FormData()
        formData.append('tipoSeguroGarantiaContrato', seguro.tipoSeguroGarantiaContrato)
        formData.append('idContrato', seguro.idContrato)
        formData.append('descricao', seguro.descricao)
        formData.append('numeroApolice', seguro.numeroApolice)
        formData.append('dataVencimento', seguro.dataVencimento)
        formData.append('documentoComprobatorio', seguro.documentoComprobatorio)
        formData.append('dataDoAvisoDeVencimento', seguro.dataDoAvisoDeVencimento)
        formData.append('valor', seguro.valor)
        
        return axiosJwt
            .post(`${api}/contratos/${seguro.idContrato}/segurosgarantias`, formData)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    atualizar(contratoId, seguro) {

        const formData = new FormData()
        formData.append('tipoSeguroGarantiaContrato', seguro.tipoSeguroGarantiaContrato)
        formData.append('idContrato', seguro.idContrato)
        formData.append('idSeguroGarantiaContrato', seguro.idSeguroGarantiaContrato)
        formData.append('descricao', seguro.descricao)
        formData.append('numeroApolice', seguro.numeroApolice)
        formData.append('dataVencimento', seguro.dataVencimento)
        formData.append('documentoComprobatorio', seguro.documentoComprobatorio)
        formData.append('nomeDocumento', seguro.documentoComprobatorio)
        formData.append('dataDoAvisoDeVencimento', seguro.dataDoAvisoDeVencimento)
        formData.append('valor', seguro.valor)

        return axiosJwt
            .put(`${api}/contratos/${contratoId}/segurosgarantias/${seguro.idSeguroGarantiaContrato}`, formData)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    obterSeguros(contratoId) {
        return axiosJwt.get(`${api}/contratos/${contratoId}/segurosgarantias`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    obterSeguro(contratoId, idSeguroGarantiaContrato) {
        return axiosJwt.get(`${api}/contratos/${contratoId}/segurosgarantias/${idSeguroGarantiaContrato}`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    download(seguro) {
        return axiosJwt
            .get(`${api}/contratos/${seguro.idContrato}/segurosgarantias/${seguro.idSeguroGarantiaContrato}/download`, {
                responseType: 'blob'
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    }
}
